<div class="billing-control-priority-modal config-payment-priority">
  <p class="billing-control-priority-modal__hint">
    Arraste os planos para definir a ordem de cobrança. O primeiro item tem a maior prioridade.
  </p>

  <app-drag-drop-list
    *ngIf="paymentPriorityList.length > 0"
    [list]="paymentPriorityList"
    [template]="priorityItemTemplate"
    (listChanged)="onPaymentPriorityReordered($event)"
    [permission]="true"
    [rowItems]="1"
  />

  <ng-template #priorityItemTemplate let-item="data">
    <span class="drag-handle" cdkDragHandle>
      <i class="pi pi-bars"></i>
    </span>
    <span class="priority-badge">
      {{ paymentPriorityList.indexOf(item) + 1 }}
    </span>
    <span class="priority-label">
      {{ getPlanLabel(item) }}
    </span>
  </ng-template>

  <p class="billing-control-priority-modal__empty" *ngIf="paymentPriorityList.length === 0">
    Nenhuma prioridade de cobrança encontrada.
  </p>

  <div class="billing-control-priority-modal__actions">
    <button
      pButton
      type="button"
      label="Cancelar"
      class="p-button-text"
      [disabled]="isSaving"
      (click)="cancel()"
    ></button>
    <button
      pButton
      type="button"
      label="Redefinir ordem"
      class="p-button-outlined p-button-secondary"
      [disabled]="isSaving"
      (click)="resetPaymentPriorityOrder()"
    ></button>
    <button
      pButton
      type="button"
      label="Salvar prioridades"
      icon="pi pi-save"
      [disabled]="isSaving || paymentPriorityList.length === 0"
      (click)="savePaymentPriority()"
    ></button>
  </div>
</div>
